<template>
    <modal
        :id="modalId"
        size="large"
        v-model="showModal"
        :title="title"
        :preloader="preloader"
        :loading="preloader"
        @submit="submit"
        :submit-btn-class="'btn-primary'"
        :btn-label="$t('save')"
    >
        <form ref="form" @submit.prevent="submit" :data-url="selectedUrl ? selectedUrl : TEAM_CULTURE">
            <div class="form-group">
                <label>Page Title</label>
                <input v-model="formData.title" type="text" class="form-control" placeholder="e.g. Building Great Things Together">
                <small class="text-danger" v-if="errors.title">{{ errors.title[0] }}</small>
            </div>

            <div v-for="(section, index) in formData.dynamic_sections" :key="index" class="border p-3 rounded mb-3">
                <div class="d-flex justify-content-between align-items-center mb-3">
                    <span class="badge badge-primary text-uppercase">Section: {{ $t(section.type) }}</span>
                    <div>
                        <button @click="moveUp(index)" class="btn btn-sm btn-light">↑</button>
                        <button @click="moveDown(index)" class="btn btn-sm btn-light ml-1">↓</button>
                        <button @click="removeSection(index)" class="btn btn-sm btn-danger ml-1">✕</button>
                    </div>
                </div>

                <div class="row p-2 bg-light rounded mb-3">
                    <div class="col-md-4 d-flex align-items-center">
                        <div class="custom-control custom-switch">
                            <input type="checkbox" v-model="section.settings.show_by_time" :id="'time-'+index" class="custom-control-input">
                            <label :for="'time-'+index" class="custom-control-label">Manage Show by Time</label>
                        </div>
                    </div>
                    <div v-if="section.settings.show_by_time" class="col-md-4 d-flex align-items-center">
                        <label class="mr-2">Start:</label>
                        <input type="time" v-model="section.settings.start_time" class="form-control form-control-sm">
                    </div>
                    <div v-if="section.settings.show_by_time" class="col-md-4 d-flex align-items-center">
                        <label class="mr-2">End:</label>
                        <input type="time" v-model="section.settings.end_time" class="form-control form-control-sm">
                    </div>
                </div>

                <div v-if="section.type === 'banner'">
                    <div class="form-group">
                        <input v-model="section.content.greeting" class="form-control mb-2" placeholder="Greeting (e.g. Good Morning!)">
                    </div>
                    <div class="form-group">
                        <input v-model="section.content.subtext" class="form-control" placeholder="Subtext">
                    </div>
                </div>

                <div v-if="section.type === 'team_shoutout'">
                    <div v-for="(item, i_index) in section.content.items" :key="i_index" class="d-flex mb-2">
                        <input v-model="item.label" class="form-control mr-2" placeholder="Event Label">
                        <input v-model="item.time" type="time" class="form-control" style="width: 150px;">
                    </div>
                    <button type="button" @click="addteam_shoutoutItem(index)" class="btn btn-link btn-sm mt-2">+ Add Time Slot</button>
                </div>

                <div v-if="section.type === 'values'">
                    <div class="form-group">
                        <input v-model="section.content.title" class="form-control mb-2" placeholder="Section Title (e.g. Our Core Values)">
                    </div>
                    <div v-for="(item, v_index) in section.content.items" :key="v_index" class="p-2 border rounded mb-2">
                        <div class="form-group">
                            <input v-model="item.title" class="form-control mb-2" placeholder="Value Title (e.g. Integrity)">
                        </div>
                        <div class="form-group">
                            <textarea v-model="item.description" class="form-control" placeholder="Value Description"></textarea>
                        </div>
                        <button type="button" @click="removeValueItem(index, v_index)" class="btn btn-sm btn-danger mt-1">Remove Value</button>
                    </div>
                    <button type="button" @click="addValueItem(index)" class="btn btn-link btn-sm mt-2">+ Add Value</button>
                </div>
            </div>

            <div class="mt-4 border-top pt-3">
              <button type="button" @click="addSection('banner')" class="btn btn-dark mr-2">Add Banner</button>
              <button type="button" @click="addSection('team_shoutout')" class="btn btn-dark mr-2">Add Team Shoutout</button>
              <button type="button" @click="addSection('values')" class="btn btn-dark mr-2">Add Values Grid</button>
              <button type="button" @click="addSection('shoutout')" class="btn btn-dark">Add Shoutout</button>
            </div>
        </form>
        <template v-slot:footer>
            <div class="d-flex justify-content-between w-100">
                <button
                    v-if="selectedUrl"
                    type="button"
                    class="btn btn-danger"
                    @click="deleteCulture"
                >
                    {{ $t('delete') }}
                </button>
                <div>
                    <button type="button" class="btn btn-secondary mr-2" @click="closeModal">{{ $t('cancel') }}</button>
                    <button type="button" class="btn btn-primary" @click="submit">{{ $t('save') }}</button>
                </div>
            </div>
        </template>
    </modal>
</template>

<script>
import { FormMixin } from '../../../../../core/mixins/form/FormMixin';
import { TEAM_CULTURE } from '../../../../Config/ApiUrl';
import { axiosGet } from "../../../../../common/Helper/AxiosHelper";

export default {
    name: 'TeamCultureCreateEditModal',
    mixins: [FormMixin],
    props: {
        tableId: String,
        selectedUrl: String,
    },
    data() {
        return {
            modalId: 'team-culture-create-edit-modal',
            showModal: false,
            formData: {
                title: '',
                is_active: true,
                dynamic_sections: [],
            },
            errors: {},
            preloader: false,
            TEAM_CULTURE: TEAM_CULTURE,
        };
    },
    created() {
        if (this.selectedUrl) {
            this.preloader = true;
            this.fetchCultureData();
        }
    },
    watch: {
        showModal(value) {
            if (!value) {
                this.$emit('close');
            }
        }
    },
    computed: {
        title() {
            return this.selectedUrl ? this.$t('edit') : this.$t('create');
        },
    },
    mounted() {
        this.showModal = true;
    },
    methods: {
        fetchCultureData() {
            axiosGet(this.selectedUrl).then(response => {
                const data = response.data;
                this.formData.title = data.title;
                this.formData.is_active = data.is_active;

                if (data.dynamic_sections && Array.isArray(data.dynamic_sections)) {
                    this.formData.dynamic_sections = data.dynamic_sections.map(section => {
                        const newSection = { ...section };
                        if (!newSection.settings) {
                            newSection.settings = { show_by_time: false, start_time: '08:00', end_time: '17:00' };
                        }
                        if (!newSection.content) {
                            if (newSection.type === 'values') {
                                newSection.content = { title: '', items: [] };
                            } else if (newSection.type === 'banner') {
                                newSection.content = { greeting: '', subtext: '' };
                            } else if (newSection.type === 'team_shoutout') {
                                newSection.content = { items: [] };
                            } else {
                                newSection.content = {};
                            }
                        }
                        return newSection;
                    });
                } else {
                    this.formData.dynamic_sections = [];
                }

                this.preloader = false;
            }).catch(({response}) => {
                this.$toastr.e(response.data.message);
                this.preloader = false;
            });
        },
        submit() {
            // Re-order sections before submitting
            this.formData.dynamic_sections.forEach((section, index) => {
                section.order = index + 1;
            });
            this.save(this.formData);
        },
        afterSuccess(response) {
            this.$toastr.s(response.data.message);
            this.$hub.$emit(`reload-${this.tableId}`);
            $('#team-culture-create-edit-modal').modal('hide');
            this.closeModal();
            this.preloader = false;
        },
        afterError(response) {
            this.errors = response.data.errors;
            this.preloader = false;
        },
        closeModal() {
            this.showModal = false;
            $('#team-culture-create-edit-modal').modal('hide');
        },
        addSection(type) {
            const newSection = {
                type: type,
                order: this.formData.dynamic_sections.length + 1,
                settings: {
                    show_by_time: false,
                    start_time: '08:00',
                    end_time: '17:00'
                },
                content: {}
            };

            if (type === 'banner') {
                newSection.content = { greeting: '', subtext: '' };
            } else if (type === 'team_shoutout') {
                newSection.content = { items: [{label: '', time: ''}] };
            } else if (type === 'values') {
                newSection.content = { title: 'Our Core Values', items: [{title: '', description: ''}] };
            }

            if (!this.formData.dynamic_sections) {
                this.$set(this.formData, 'dynamic_sections', []);
            }
            this.formData.dynamic_sections.push(newSection);
        },
        addteam_shoutoutItem(sectionIndex) {
            if (!this.formData.dynamic_sections[sectionIndex].content.items) {
                 this.$set(this.formData.dynamic_sections[sectionIndex].content, 'items', []);
            }
            this.formData.dynamic_sections[sectionIndex].content.items.push({ label: '', time: '' });
        },
        addValueItem(sectionIndex) {
            if (!this.formData.dynamic_sections[sectionIndex].content.items) {
                this.$set(this.formData.dynamic_sections[sectionIndex].content, 'items', []);
            }
            this.formData.dynamic_sections[sectionIndex].content.items.push({ title: '', description: '' });
        },
        removeValueItem(sectionIndex, itemIndex) {
            this.formData.dynamic_sections[sectionIndex].content.items.splice(itemIndex, 1);
        },
        removeSection(index) {
            this.formData.dynamic_sections.splice(index, 1);
        },
        moveUp(index) {
            if (index > 0) {
                const item = this.formData.dynamic_sections.splice(index, 1)[0];
                this.formData.dynamic_sections.splice(index - 1, 0, item);
            }
        },
        moveDown(index) {
            if (index < this.formData.dynamic_sections.length - 1) {
                const item = this.formData.dynamic_sections.splice(index, 1)[0];
                this.formData.dynamic_sections.splice(index + 1, 0, item);
            }
        },
        deleteCulture() {
            this.$hub.$emit('show-delete-confirmation', {
                url: this.selectedUrl,
                tableId: this.tableId
            });
            this.closeModal(); // Close the edit modal after triggering delete confirmation
        }
    },
};
</script>
